// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "reactPlayerPreview" + "." + "2e51141f" + ".chunk.js";
};